import { getFileFormatCategoryFromMimeType } from "@app/usecases/VersionUseCases/utils";
import { Button } from "@design-system/Inputs/Button";
import { FlexCol, FlexRow } from "@design-system/Layout/Flex";
import { Text } from "@design-system/Typography/Text";
import { ExtensionTag } from "../../ExtensionTag";

type FileType = {
    id: string;
    signedUrl?: string | null;
    name?: string | null;
    mimeType?: string | null;
    documentVersions?:
        | {
              document?: {
                  name?: string | null;
              } | null;
          }[]
        | null;
};

export const UploadedDocumentsList = <T extends FileType>({
    files,
    onRemove,
    disableDelete,
}: {
    files: T[];
    onRemove: (fileId: string) => void;
    disableDelete?: boolean;
}) => {
    const handleDeleteDocumentClick = (fileId: string) => {
        return () => {
            onRemove(fileId);
        };
    };

    return (
        <FlexCol gap="1" w="full">
            {files.map((file) => (
                <FlexRow
                    alignItems="center"
                    justifyContent="between"
                    gap="1"
                    alignSelf="start"
                    key={file.id}
                >
                    <a
                        href={file.signedUrl || undefined}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-inherit"
                    >
                        <FlexRow
                            alignItems="center"
                            gap="3"
                            alignSelf="stretch"
                        >
                            <ExtensionTag
                                name={getFileFormatCategoryFromMimeType(
                                    file.mimeType || "application/pdf",
                                )}
                            />
                            <Text variant="body-bold" color="brand">
                                {(!!file.documentVersions?.length &&
                                    file.documentVersions[0]?.document?.name) ||
                                    file.name}
                            </Text>
                        </FlexRow>
                    </a>
                    {!disableDelete && (
                        <Button
                            size="sm"
                            variant="text"
                            onClick={handleDeleteDocumentClick(file.id || "")}
                        >
                            <Button.Icon name="trash" size="sm" />
                        </Button>
                    )}
                </FlexRow>
            ))}
        </FlexCol>
    );
};
